export const fontFamily = [
    "Roboto",
    "Open-Sans",
    "Arial",
    "Times-New-Roman",
    "Arial-Unicode-MS",
    "Abhaya-Libre",
    "Anek-Bangla",
    "Anek-Kannada",
    "Anek-Odia",
    "Cairo",
    "Catamaran",
    "Gayathri",
    "Hanuman",
    "Hind-Madurai",
    "Hind-Siliguri",
    "Hind-Vadodara",
    "Jomolhari",
    "Kanit",
    "M-PLUS-Rounded-1c",
    "Mandali",
    "Manjari",
    "Montserrat",
    "Mukta",
    "Mukta-Mahee",
    "Mukta-Malar",
    "Mukta-Vaani",
    "Nanum-Gothic",
    "Nokora",
    "Noto-Kufi-Arabic",
    "Noto-Naskh-Arabic",
    "Noto-Sans",
    "Noto-Sans-Arabic",
    "Noto-Sans-Bengali",
    "Noto-Sans-Devanagari",
    "Noto-Sans-Gujarati",
    "Noto-Sans-Gurmukhi",
    "Noto-Sans-Hebrew",
    "Noto-Sans-HK",
    "Noto-Sans-JP",
    "Noto-Sans-Kannada",
    "Noto-Sans-Khmer",
    "Noto-Sans-KR",
    "Noto-Sans-Malayalam",
    "Noto-Sans-Myanmar",
    "Noto-Sans-Oriya",
    "Noto-Sans-SC",
    "Noto-Sans-Sinhala",
    "Noto-Sans-Tamil",
    "Noto-Sans-TC",
    "Noto-Sans-Telugu",
    "Noto-Sans-Thai",
    "Noto-Serif-Bengali",
    "Noto-Serif-Devanagari",
    "Noto-Serif-Gujarati",
    "Noto-Serif-Gurmukhi",
    "Noto-Serif-Hebrew",
    "Noto-Serif-JP",
    "Noto-Serif-Kannada",
    "Noto-Serif-Khmer",
    "Noto-Serif-KR",
    "Noto-Serif-Malayalam",
    "Noto-Serif-Myanmar",
    "Noto-Serif-SC",
    "Noto-Serif-Sinhala",
    "Noto-Serif-Tamil",
    "Noto-Serif-TC",
    "Noto-Serif-Telugu",
    "Noto-Serif-Thai",
    "Noto-Serif-Tibetan",
    "Oswald",
    "Padauk",
    "Poppins",
    "Prompt",
    "Raleway",
    "Rubik",
    "Sawarabi-Gothic",
    "Uchen",
];
  
export const fontSizeArr = [
    "8px",
    "9px",
    "10px",
    "12px",
    "14px",
    "16px",
    "20px",
    "24px",
    "32px",
    "42px",
    "54px",
    "68px",
    "84px",
    "98px",
];
  
export const lineHeight = ['1-0', '1-15', '1-5', '2-0', '2-5', '3-0'];

export const tableActions = ['Insert-row-above', 'Insert-row-below', 'Insert-column-left', 'Insert-column-right', 'Delete-row', 'Delete-column', 'Delete-table'];


export const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      [{ font: fontFamily }],
      [{ size: fontSizeArr }], // custom dropdown

      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction
      [{ align: [] }],

      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      ["link", "image", "video"],

      ["blockquote", "code-block"],
      [{ lineheight: lineHeight }],
      ['table'],
      [{ tableaction: tableActions }],
      ['hr'],
      ["clean"],
    ],
    table: true,
    resize: {
      locale: {
        // change them depending on your language
        altTip: "Hold down the alt key to zoom",
        floatLeft: "Left",
        floatRight: "Right",
        center: "Center",
        restore: "Restore",
      },
    },
  };

export const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "code-block",
    "header",
    "list",
    "indent",
    "script",
    "direction",
    "size",
    "font",
    "align",
    "link",
    "image",
    "video",
    "color",
    "background",
    "lineheight",
    "table",
    "tableaction",
    "hr", 
];
  
